import axiosClient from '../../configs/axios';


class cylindeundermaintaince {
    // Get list 
    async getcylindeundermaintaincerepotlist(params) {
        try {
            const response = await axiosClient.get(
                `/reports/EmptyCylinderMaintenance?page=${params.page}&size=${params.size}&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    



 








   
    
}

export default new cylindeundermaintaince(); 